import { ITheme, mergeStyleSets, getTheme, IStyle, IRawStyle } from '@fluentui/react';
import React from 'react';

interface IPriceDisplayProps {
  price: number;
  fontSize?: IRawStyle | undefined;
}

const getStyleClasses = (theme: ITheme, rootFontSize: IRawStyle) => {
  const root: IStyle = {
    padding: 0,
    fontSize: rootFontSize.fontSize,
  };

  const priceSup: IStyle = {
    fontSize: '0.43em',
    lineHeight: '0.57em',
    fontWeight: 600,
    verticalAlign: 'super',
  };

  const price: IStyle = {
    fontSize: rootFontSize.fontSize,
    lineHeight: rootFontSize.lineHeight,
    fontWeight: 600,
  };

  return mergeStyleSets({
    root,
    priceSup,
    price,
  });
}

export const PriceDisplay: React.FunctionComponent<IPriceDisplayProps> = (props) => {
  const theme = getTheme();
  const font = props.fontSize ?? theme.fonts.xxLarge;
  const cs = getStyleClasses(theme, font);
  const literalPrice = props.price / 100;
  const dollars = Math.floor(literalPrice);
  const cents = (props.price - (dollars * 100)).toString().padStart(2, "0");

  return (
    <div
      className={cs.root}
      aria-label={`Price $${literalPrice.toFixed(2)}`}
    >
      <sup className={cs.priceSup}>$</sup>
      <span className={cs.price}>{dollars.toLocaleString()}</span>
      <sup className={cs.priceSup}>{`.${cents}`}</sup>
    </div>
  );
};
